/**
 * 开发团队 API 客户端
 */

export interface TeamSkill {
  skill_tag?: number | null
  skill_tag_string?: string | null
}

export interface TeamIndustry {
  industry_tag?: number | null
  industry_tag_string?: string | null
}

export interface TeamBasicInfo {
  city?: number | null
  city_string?: string | null
  team_size?: string | null
}

export interface TeamBusinessInfo {
  ent_name?: string | null
  established_time?: string | null
}

export interface TeamIntroduction {
  is_have_video?: boolean | null
}

export interface Team {
  id: number
  nickname?: string | null
  avatar?: string | null
  success_rate?: number | null
  recently_active?: string | null
  credit_score_personal?: number | null
  is_low_credit?: boolean | null
  basic_info?: TeamBasicInfo | null
  business_info?: TeamBusinessInfo | null
  introduction?: TeamIntroduction | null
  skills: TeamSkill[]
  industries: TeamIndustry[]
}

export interface TeamListResponse {
  data: Team[]
  pagination: {
    total: number
    page: number
    page_size: number
    total_pages: number
  }
}

export interface TeamFilters {
  industryTag?: number
  city?: number
  page?: number
}

export async function getTeams(
  filters: TeamFilters = {}
): Promise<TeamListResponse> {
  const params = new URLSearchParams()

  if (filters.industryTag !== undefined) {
    params.append('industryTag', filters.industryTag.toString())
  } else {
    params.append('industryTag', '-1')
  }

  if (filters.city !== undefined) {
    params.append('city', filters.city.toString())
  } else {
    params.append('city', '-1')
  }

  params.append('page', (filters.page || 1).toString())

  const baseUrl = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000'
  const url = `${baseUrl}/api/v1/teams?${params.toString()}`

  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`获取团队列表失败: ${response.statusText}`)
  }

  return response.json()
}

export async function getTeamById(id: number): Promise<Team> {
  const baseUrl = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000'
  const url = `${baseUrl}/api/v1/teams/${id}`

  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`获取团队详情失败: ${response.statusText}`)
  }

  return response.json()
}
